import { requestTimeout, handleResponse } from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem(accessToken),
})

const buildQuery = (filters = {}) => {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value)
    })
    const qs = params.toString()
    return qs ? `?${qs}` : ''
}

export const gatewayMerchantAccountApi = {
    _get: _getMerchantAccounts,
    _create: _createMerchantAccount,
    _update: _updateMerchantAccount,
    _delete: _deleteMerchantAccount,
}

export const clientGatewayAccountApi = {
    _get: _getClientGatewayAccounts,
    _create: _createClientGatewayAccount,
    _update: _updateClientGatewayAccount,
    _delete: _deleteClientGatewayAccount,
}


// ─── Gateway Merchant Accounts ─────────────────────────────────────────────────

async function _getMerchantAccounts(filters = {}) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `gatewayMerchantAccounts${buildQuery(filters)}`, {
        method: 'GET',
        headers: authHeaders(),
    })).then(handleResponse)
}

async function _createMerchantAccount(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `gatewayMerchantAccounts`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _updateMerchantAccount(id, data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `gatewayMerchantAccounts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _deleteMerchantAccount(id) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `gatewayMerchantAccounts/${id}`, {
        method: 'DELETE',
        headers: authHeaders(),
    })).then(handleResponse)
}


// ─── Client Gateway Accounts ────────────────────────────────────────────────────

async function _getClientGatewayAccounts(filters = {}) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `clientGatewayAccounts${buildQuery(filters)}`, {
        method: 'GET',
        headers: authHeaders(),
    })).then(handleResponse)
}

async function _createClientGatewayAccount(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `clientGatewayAccounts`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _updateClientGatewayAccount(id, data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `clientGatewayAccounts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _deleteClientGatewayAccount(id) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `clientGatewayAccounts/${id}`, {
        method: 'DELETE',
        headers: authHeaders(),
    })).then(handleResponse)
}
